import { InputNumber } from 'antd'
import { useMemo } from 'react'

import { Trans } from '@/components/Trans'
// import { Button } from '@/components/base/Button'
// import ResetToDefault from '@/assets/icons/reset.svg?react'
import { usePermissionForm } from '@/pages/teams/permissionQuota/PermissionFormContext'

const GiB = 1024 ** 3
const toGiB = (bytes: number | null | undefined) =>
  typeof bytes === 'number' && bytes > 0 ? Math.floor(bytes / GiB) : 0
// const toBytes = (gib: number | null | undefined) =>
//   typeof gib === 'number' && gib >= 0 ? Math.floor(gib * GiB) : 0

export function InstanceQuota() {
  const { scope, form, setForm, teamDefaults, quotaLimits } = usePermissionForm()

  const hints = useMemo(() => {
    const t = teamDefaults
    return {
      meshNet: t?.meshNetQuota,
      meshEndpoint: t?.meshEndpointQuota,
      instanceQty: t?.instanceQtyQuota,
      snapQty: t?.snapQtyQuota,
      storageGiB: toGiB(t?.storageCapBytesQuota ?? 0),
    }
  }, [teamDefaults])

  const set = <K extends keyof typeof form>(key: K, val: number) => {
    setForm({ ...form, [key]: val })
  }

  const maxInstanceQty = quotaLimits?.instanceQty ?? 200

  // const resetSectionToDefault = () => {
  //   if (scope === 'member' && teamDefaults) {
  //     setForm({
  //       ...form,
  //       meshNetQuota: teamDefaults.meshNetQuota,
  //       meshEndpointQuota: teamDefaults.meshEndpointQuota,
  //       instanceQtyQuota: teamDefaults.instanceQtyQuota,
  //       snapQtyQuota: teamDefaults.snapQtyQuota,
  //       storageCapBytesQuota: teamDefaults.storageCapBytesQuota,
  //     })
  //   } else {
  //     setForm({
  //       ...form,
  //       meshNetQuota: 0,
  //       meshEndpointQuota: 0,
  //       instanceQtyQuota: 0,
  //       snapQtyQuota: 0,
  //       storageCapBytesQuota: 0,
  //     })
  //   }
  // }

  return (
    <div className="mt-10">
      <div className="flex items-center gap-x-2">
        <div className="h-[20px] border-secondary border-solid border-l-4" />
        <span className="h6 text-primary">
          <Trans i18nKey="team.permissionQuota.instanceQuota">Instances Quota</Trans>
        </span>
        {/* <Button
          type="link"
          className="t-sb text-btn-primary bg-btn-primary/10 w-40 h-8 p-1 text-center flex items-center justify-center gap-x-1"
          onClick={resetSectionToDefault}
          loading={loading}
        >
          <ResetToDefault /> <Trans i18nKey="member.resetToDefault">Reset to Default</Trans>
        </Button> */}
      </div>

      {/* Grid */}
      <div className="mt-8 grid grid-cols-2 gap-6">
        {/* Instance Quota */}
        <div>
          <div className="t-sb mb-2">
            <Trans i18nKey="team.permissionQuota.memberInstanceQuota">Member Instance Quota</Trans>
          </div>
          <InputNumber
            min={0}
            className="w-full h-11 flex items-center t-sb"
            value={form.instanceQtyQuota}
            onChange={(v) => set('instanceQtyQuota', Number(v ?? 0))}
          />
          {scope === 'member' && teamDefaults && (
            <div className="mt-1 t-sm text-secondary">Team default: {hints.instanceQty}</div>
          )}
          {form.instanceQtyQuota > maxInstanceQty && (
            <div className="mt-1 t-sm text-error">
              <Trans i18nKey="team.permissionQuota.maxInstanceQty" values={{ max: maxInstanceQty }}>
                Maximum instance quantity is {maxInstanceQty}.
              </Trans>
            </div>
          )}
        </div>

        {/* Mesh Endpoints */}
        {/* <div>
          <div className="t-sb mb-2">
            <Trans>Mesh endpoints</Trans>
          </div>
          <InputNumber
            min={0}
            className="w-full h-9"
            value={form.meshEndpointQuota}
            onChange={(v) => set('meshEndpointQuota', Number(v ?? 0))}
          />
          {scope === 'member' && teamDefaults && (
            <div className="mt-1 t-sm text-secondary">Team default: {hints.meshEndpoint}</div>
          )}
        </div> */}

        {/* Instances */}
        {/* <div>
          <div className="t-sb mb-2">
            <Trans>Instances</Trans>
          </div>
          <InputNumber
            min={0}
            className="w-full h-9"
            value={form.instanceQtyQuota}
            onChange={(v) => set('instanceQtyQuota', Number(v ?? 0))}
          />
          {scope === 'member' && teamDefaults && (
            <div className="mt-1 t-sm text-secondary">Team default: {hints.instanceQty}</div>
          )}
        </div> */}
      </div>
    </div>
  )
}
